import React from "react"
import PropTypes from "prop-types"

import "./Footer.less"
import { Link } from "gatsby"

class FooterTop extends React.Component {
  render() {
    return (
        <div className="footer-menu">
          {this.props.footerMenu.map(function (item, i) {
            return (
              <div className="footer-menu-list" key={i}>
                <Link to={item.url}>
                  {item.text}
                </Link>
              </div>
            )
          })}
        </div>
    )
  }
}

FooterTop.prototypes = {
  footerMenu: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
}

export default FooterTop
